import { Tabs } from "antd";
import React, { useEffect } from "react";
import "../../assets/style/pageStyle/store.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  resetState,
  resetStatus,
  setOpenModalGetLogStore,
} from "../../services/slice/StoreSlice";
import { storeProductSelector } from "../../services/selector/index.";
import Notify from "../../components/common/Notify";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import ModalEditProduct from "../../components/common/Modal/edit/ModalEditProduct";
import ModalPreviewProduct from "../../components/common/Modal/getDetail/ModalPreviewProduct";
import ModalAddProduct from "../../components/common/Modal/add/ModalAddProduct";
import ModalGetLog from "../../components/common/Modal/getLog/ModalGetLog";
import TabStaffChatUp from "../../components/common/Tabs/TabStaffChatUp";
const ChatStatistics = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [tab, setTab] = useState(1);
  const stateStore = useSelector(storeProductSelector);
  const [showPreview, setShowPreview] = useState(false);

  useEffect(() => {
    return () => dispatch(resetState());
  }, [dispatch]);

  const handleChangeTabs = (key) => {
    setTab(key);
  };

  return (
    <>
      <div className="wrapperStoreManager">
        {showPreview ? (
          <ModalPreviewProduct open={showPreview} setOpen={setShowPreview} />
        ) : null}
        {stateStore.isOpenModalAddProduct && (
          <ModalAddProduct title={"Thêm mới sản phẩm"} />
        )}
        {stateStore.isOpenModalEdit && <ModalEditProduct />}
        {stateStore.isOpenModalGetLog && (
          <ModalGetLog
            open={stateStore.isOpenModalGetLog}
            setOpen={setOpenModalGetLogStore}
            data={stateStore.dataLog}
          />
        )}
        <Notify
          isNotify={stateStore.isNotify}
          reset={resetStatus}
          title={"Bkav Pro"}
          content={stateStore.msg}
          type={stateStore.typeNotify}
        />
        <Tabs
          activeKey={tab}
          onChange={handleChangeTabs}
          items={[
            {
              label: t("Khách hàng chat lên"),
              key: 1,
              children:
                tab === 1 ? <TabStaffChatUp type="staffChatUp" /> : null,
            },
            {
              label: t("Nhân viên chat xuống"),
              key: 2,
              children:
                tab === 2 ? <TabStaffChatUp type="staffChatDown" /> : null,
            },
            {
              label: t("Số phiên chat"),
              key: 3,
              children:
                tab === 3 ? <TabStaffChatUp type="totalChat" /> : null,
            },
          ]}
        />
      </div>
    </>
  );
};

export default ChatStatistics;
